/* eslint-disable max-len */
import { defineMessages } from 'react-intl'

export default defineMessages({
  maxCapacityAcrossMultipleSlots: {
    id: 'eventDisclosure.multipleTimeslots',
    defaultMessage: 'Maximum capacity for all time slots is {totalCapacity} {totalCapacity, plural, one {person} other {people}}.',
  },
  maxCapacityForSingleSlot: {
    id: 'eventDisclosure.singleTimeslot',
    defaultMessage: 'Maximum capacity for this event is {totalCapacity} {totalCapacity, plural, one {person} other {people}}.',
  },
  noMaxCapacityForEvent: {
    id: 'eventDisclosure.noCapacity',
    defaultMessage: 'There is no maximum capacity set for this event.',
  },
  eventSetCapacity: {
    id: 'eventDisclosure.eventSetCapacity',
    defaultMessage: 'Maximum capacity may vary by date. See individual event for more.',
  },
  eventDisclosureInfo: {
    id: 'eventDisclosure.header',
    defaultMessage: 'Event disclosure information',
  },
  eventDisclosureBody: {
    id: 'eventDisclosure.bodyDelivery',
    defaultMessage: 'All tickets are delivered electronically to the email address you enter at checkout, with no additional fee or service charge.',
  },
  continue: {
    id: 'eventDisclosure.continue',
    defaultMessage: 'Continue',
  },
})
